import React from 'react'
import { graphql } from "gatsby";
import Layout from '../../components/layout';
import BrowseArticles from '../../components/browseArticles';

export default function Articles(props) {

  const articles = props.data.allPrismicNewsPress.nodes

  return (
    <Layout>
      <div className='ariclesPageWrapper'>
        <BrowseArticles articles={articles} location={props.location} />
      </div>
    </Layout>
  )
}

export const query = graphql`{
  allPrismicNewsPress(sort: {order: DESC, fields: data___date}) {
    nodes {
      uid
      tags
      data {
        date
        category
        title
      }
    }
  }
}`  